import { render } from "./BurnRestrictionsView.vue?vue&type=template&id=010e4bae"
import script from "./BurnRestrictionsView.vue?vue&type=script&lang=js"
export * from "./BurnRestrictionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__